export default __webpack_public_path__ + "static/media/washermiddle.dbf7a551.jpg";